import React from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'

import enUS from 'rc-calendar/lib/locale/en_US'
import MonthCalendar from 'rc-calendar/lib/MonthCalendar'
import DatePicker from 'rc-calendar/lib/Picker'

import { styles } from './styles'

import ArrowIcon from 'Assets/Images/icons/arrow'
import Delete from 'Assets/Images/icons/close'

const disabledDate = value =>
  value.year() > moment().year() ||
  (value.year() === moment().year() && value.month() > moment().month())

const calendar = <MonthCalendar locale={enUS} disabledDate={disabledDate} />

const MonthSelector = ({
  title,
  value,
  onChange,
  disabled = false,
  classes,
}) => (
  <div className={classes.container}>
    <span className={classes.datePickerHeaderTitle}>{title}</span>
    <div className={classes.inputWrapper}>
      <DatePicker
        animation="slide-up"
        value={!value || value === 'All' ? null : moment(value)}
        calendar={calendar}
        onChange={onChange}
        disabled={disabled}
      >
        {({ value }) => (
          <input
            className={classes.input}
            value={value ? moment(value).format('MMM-YYYY') : 'All'}
          />
        )}
      </DatePicker>
      {value && value !== 'All' ? (
        <Delete
          className={classes.deleteIcon}
          onClick={() => onChange('All')}
        />
      ) : null}
      <ArrowIcon className={classes.icon} />
    </div>
  </div>
)

export default injectStyles(styles)(MonthSelector)
